import styled from 'styled-components';

import { Select } from 'components/modules/Insurance/Insurance.styles';

import { LIST, NAME } from './TypeOfUse.constants';

export const TypeOfUseSelect = styled(Select).attrs({
  list: LIST,
  name: NAME,
  placeholder: 'Цель использования',
})``;
